<template>
  <div>
    <Hero
      subheadline="Entdecken Sie den Schwarzwald"
      headline="Schwarzwaldregion Belchen"
      :src="chooseTitleImage()"
    />
    <section class="wrapper mt-8 sm:mt-20">
      <h1 class="sm:text-center font-serif">Die Urlaubsregion</h1>
      <p class="font-semibold text-gray-700 leading-relaxed text-xl mt-4">
        Aitern, ein beschauliches Schwarzwalddorf, liegt im
        <a
          class="
            text-red-500
            hover:text-red-600
            ease-in-out
            duration-150
            transition-colors
          "
          href="https://www.naturpark-suedschwarzwald.de/"
          target="_blank"
          >Naturpark Südschwarzwald</a
        >, am Fuße des Belchen, dem schönsten Aussichtsberg im Schwarzwald. Wir
        wohnen in der
        <a
          class="
            text-red-500
            hover:text-red-600
            ease-in-out
            duration-150
            transition-colors
          "
          href="https://www.schwarzwaldregion-belchen.de/"
          target="_blank"
          >Schwarzwaldregion Belchen</a
        >
        nahe Feldberg, Freiburg und Basel. Die Region bildet das Zentrum des
        <a
          class="
            text-red-500
            hover:text-red-600
            ease-in-out
            duration-150
            transition-colors
          "
          href="https://www.biosphaerengebiet-schwarzwald.de/"
          target="_blank"
          >Biosphärengebiet Schwarzwald</a
        >. Von hier aus können Sie in schönen Tagesausflügen die nahe Schweiz
        oder das benachbarte Elsass bequem erreichen.
      </p>
      <Quote class="mt-6 sm:mt-10" :text="quotes.first.text" :author="quotes.first.author" />
    </section>
    <section role="main" class="max-w-4xl px-4 mx-auto mt-12">
      <p class="mt-4">
        Fühlen Sie die Ruhe und Beschaulichkeit der Natur. Genießen Sie das
        faszinierende Schwarzwaldpanorama. Atmen Sie die frische Luft. Hören Sie
        klare Gebirgsbäche rauschen und erleben Sie Glücksmomente auf den
        Bergen.
      </p>
      <p class="mt-2">
        Wenn Sie die Ruhe suchen, gerne wandern und die unberührte Natur
        genießen, Mountainbike fahren, Nordicwalking, Trailrunning, Ausflüge
        unternehmen und im Winter gerne Wintersport betreiben, sind Sie bei uns
        goldrichtig
      </p>
      <p class="mt-2">
        Lernen Sie auch die Schwarzwälder Gastfreundschaft kennen: ... ehrlich,
        schlicht und herzlich!
      </p>
    </section>
    <section class="bg-gray-100 mt-12 sm:mt-24 pt-12 pb-24 sm:pt-16 sm:pb-40">
      <div class="max-w-6xl px-2 mx-auto">
        <h2 class="text-center">Sommerimpressionen</h2>
        <!-- <p class="wrapper text-gray-700 mt-4">
          Auch im Winter finden Sie hier in Aitern ein Paradies, klassisch mit
          Ski, Langlauf und Snowboard, aber auch ohne Bretter unter den Füßen,
          beim Rodeln, Winterwandern, Schneeschuhlaufen oder Schneemann
          bauen...... Jeder kommt hier auf seine Kosten! Erleben Sie einen
          Wintertraum!
        </p> -->
        <ImageGallery class="mt-4 sm:mt-12" :images="items.summer" />
      </div>
    </section>
    <section class="bg-gray-900 pt-12 pb-24 sm:pt-16 sm:pb-40">
      <div class="max-w-6xl px-2 mx-auto">
        <h2 class="text-center text-white">
          Aitern im Winter
        </h2>
        <p class="wrapper text-gray-100 mt-4">
          Auch im Winter finden Sie hier in Aitern ein Paradies, klassisch mit
          Ski, Langlauf und Snowboard, aber auch ohne Bretter unter den Füßen,
          beim Rodeln, Winterwandern, Schneeschuhlaufen oder Schneemann
          bauen...... Jeder kommt hier auf seine Kosten! Erleben Sie einen
          Wintertraum!
        </p>
        <ImageGallery class="mt-8 sm:mt-12" :images="items.winter" />
      </div>
    </section>
  </div>
</template>

<script>
import ImageGallery from '../components/ImageGallery.vue'
import Hero from '../components/Hero.vue'
import currentSeason from '../services/getSeason'
import Quote from '../components/Quote.vue'

export default {
  name: 'Destination',
  components: { ImageGallery, Hero, Quote },
  methods: {
    handleScroll(event) {
      if (window.scrollY > 0) {
        this.setDarkNav()
      } else {
        this.setWhiteNav()
      }
    },
    chooseTitleImage() {
      let path = ''
      if (this.summerSeason) {
        path = this.items.summer[0].src
      } else {
        path = this.items.winter[2].src
      }
      return path
    },
    setDarkNav() {
      this.$store.dispatch('setDarkNav')
    },
    setWhiteNav() {
      this.$store.dispatch('setWhiteNav')
    },
  },
  mounted() {
    this.setWhiteNav()
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    this.setDarkNav()
    window.removeEventListener('scroll', this.handleScroll)
  },
  data() {
    return {
      name: 'This is the Imagegallery component',
      quotes: {
        first: {
          text: 'Die Welt gehört dem, der sie genießt.',
          author: 'G.Leopardi',
        },
      },
      items: {
        summer: [
          {
            src: 'img/imp_sommer/R6__0628.jpg',
            w: 1440,
            h: 960,
            thumbnail: 'img/imp_sommer/thumb/R6__0628.jpeg',
          },
          {
            src: 'img/imp_sommer/R6__0481.jpg',
            w: 1440,
            h: 960,
            thumbnail: 'img/imp_sommer/thumb/R6__0481.jpeg',
            description:
              'Alpenpanorama beim Sonnenaufgang auf dem Belchengipfel',
          },
          {
            src: 'img/imp_sommer/DSC02567.jpg',
            w: 1440,
            h: 960,
            thumbnail: 'img/imp_sommer/thumb/DSC02567.jpeg',
          },
          // {
          //   src: 'img/imp_sommer/5V6A8217.jpg',
          //   w: 1440,
          //   h: 960,
          //   thumbnail: 'img/imp_sommer/5V6A8217.jpg',
          // },
          {
            src: 'img/imp_sommer/R6__0818.jpg',
            w: 1440,
            h: 960,
            thumbnail: 'img/imp_sommer/thumb/R6__0818.jpeg',
          },
          {
            src: 'img/imp_sommer/IMG_8263.jpeg',
            w: 1920,
            h: 1440,
            thumbnail: 'img/imp_sommer/thumb/IMG_8263.jpeg',
          },
          {
            src: 'img/imp_sommer/IMG_1581.jpeg',
            w: 1920,
            h: 1440,
            thumbnail: 'img/imp_sommer/thumb/IMG_1581.jpeg',
          },
          // {
          //   src: 'img/imp_sommer/DSC00435.jpg',
          //   w: 1440,
          //   h: 960,
          //   thumbnail: 'img/imp_sommer/DSC00435.jpg',
          // },
        ],
        winter: [
          {
            src: 'img/imp_winter/IMG_0459.jpg',
            w: 1440,
            h: 960,
            thumbnail: 'img/imp_winter/thumb/IMG_0459.jpeg',
          },
          {
            src: 'img/imp_winter/juli-06930.jpeg',
            w: 1440,
            h: 960,
            thumbnail: 'img/imp_winter/thumb/juli-06930.jpeg',
          },
          {
            src: 'img/imp_winter/Belchen_2016_B_Asal-8554.jpeg',
            w: 1920,
            h: 1280,
            thumbnail: 'img/imp_winter/thumb/Belchen_2016_B_Asal-8554.jpeg',
          },
          {
            src: 'img/imp_winter/IMG_8565.jpg',
            w: 1920,
            h: 1280,
            thumbnail: 'img/imp_winter/thumb/IMG_8565.jpeg',
          },
          {
            src: 'img/imp_winter/DSC06875.jpg',
            w: 1920,
            h: 1280,
            thumbnail: 'img/imp_winter/thumb/DSC06875.jpeg',
          },
          {
            src: 'img/imp_winter/feldberg-7338.jpeg',
            w: 1920,
            h: 1280,
            thumbnail: 'img/imp_winter/thumb/feldberg-7338.jpeg',
          },
        ],
      },
    }
  },
  computed: {
    summerSeason() {
      let seasonState = true
      const season = currentSeason()

      if (season === 'winter') {
        seasonState = false
      }
      return seasonState
    },
  },
}
</script>
